<template>
  <div>
    <div class="section-title">
      {{ $t("message.common.additionalCategories") }}
    </div>
    <div v-if="additionalCategories.length">
      <v-chip
        v-for="item in additionalCategories"
        :key="item.id"
        outlined
        class="mr-2 my-1"
      >
        {{ item.name }}
        <v-icon
          v-if="canEditFacilityAdditionalCategories"
          class="ml-2 mr--1"
          color="grey"
          @click="showCategoryDeleteConfirmationDialog(item.id)"
          :disabled="isReadonly"
        >
          icon-close
        </v-icon>
      </v-chip>
      <ui-button
        v-if="
          additionalCategories.length < maxAdditionalCategories &&
            canEditFacilityAdditionalCategories
        "
        color="primary"
        icon="mdi-plus"
        class="my-1"
        outlined
        @click="dialog.add = true"
        :disabled="isReadonly"
      >
        {{ $t("message.common.add") }}
      </ui-button>
    </div>
    <ui-button
      v-else-if="canEditFacilityAdditionalCategories"
      color="primary"
      icon="mdi-plus"
      class="my-1"
      outlined
      block
      @click="dialog.add = true"
      :disabled="isReadonly"
    >
      {{ $t("message.common.add") }}
    </ui-button>

    <v-chip v-else color="grey-darker" class="my-1">
      {{ $t("message.common.noData") }}
    </v-chip>
    <InfoBox
      v-if="canEditFacilityAdditionalCategories && infoBoxText"
      class="mt-2"
      :text="$t(infoBoxText)"
      :more-info-link="
        GMB_VERIFICATION_INFO_LINKS[GMB_CHANGE_FIELD_TYPE.CATEGORY](
          $i18n.locale
        )
      "
    />

    <SectionLoader :status="loading" :opacity="0.5" />

    <AddCategoryDialog
      :isOpen="dialog.add"
      :maxWidth="1154"
      :added-categories-ids="additionalCategoriesIds"
      :chosen-category-type="categoryTypes.ADDITIONAL"
      @add="saveCategory"
      @close="dialog.add = false"
    />

    <v-dialog v-model="dialog.delete" max-width="450">
      <v-card class="pa-6">
        <p class="mb-8 text-center">
          {{
            $t("message.facilityDetails.categories.deleteCategoryDialogTitle")
          }}
        </p>

        <div class="d-flex justify-center">
          <ui-button
            outlined
            class="mr-3"
            color="primary"
            @click="hideCategoryDeleteConfirmationDialog"
          >
            {{ $t("message.common.cancel") }}
          </ui-button>
          <ui-button color="primary" @click="deleteCategory(deleteCategoryId)">
            {{ $t("message.common.confirmDelete") }}
          </ui-button>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { CategoryType } from "@/enums/category-type";
import { permissionsInfo } from "@/helpers/mixins/permissions-info";

import SectionLoader from "@/components/Loader/SectionLoader.vue";
import AddCategoryDialog from "@/components/FacilityDetails/Dialog/AddCategoryDialog.vue";
import InfoBox from "@/components/ui/InfoBox.vue";
import {
  GMB_CHANGE_FIELD_TYPE,
  GMB_VERIFICATION_INFO_LINKS
} from "@/helpers/mixins/gmb-update-verification";

export default {
  name: "AdditionalCategories",
  data() {
    return {
      dialog: {
        add: false,
        delete: false
      },
      chosenCategoryType: null,
      deleteCategoryId: null,
      maxAdditionalCategories: 9,
      GMB_VERIFICATION_INFO_LINKS,
      GMB_CHANGE_FIELD_TYPE
    };
  },
  mixins: [permissionsInfo],
  components: {
    SectionLoader,
    AddCategoryDialog,
    InfoBox
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    isReadonly: {
      type: Boolean,
      required: true
    },
    additionalCategories: {
      type: Array,
      default: () => []
    },
    infoBoxText: {
      type: String,
      default: "message.gmbVerification.category"
    }
  },
  computed: {
    additionalCategoriesIds() {
      return this.additionalCategories.map(cat => cat.id);
    },
    categoryTypes() {
      return CategoryType;
    }
  },
  methods: {
    saveCategory({ category }) {
      this.$emit("save", { category, type: CategoryType.ADDITIONAL });
    },

    deleteCategory(id) {
      this.$emit("delete", id);
      this.hideCategoryDeleteConfirmationDialog();
    },

    showCategoryDeleteConfirmationDialog(id) {
      this.deleteCategoryId = id;
      this.dialog.delete = true;
    },

    hideCategoryDeleteConfirmationDialog() {
      this.deleteCategoryId = null;
      this.dialog.delete = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.section-title {
  @include sectionTitle();
}

.v-chip {
  @include vChip();
  white-space: pre-wrap;
}

.mr--1 {
  margin-right: $spacing * -0.75;
}
</style>
